(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/OneDaciaHeaderDesktopMenu"] = factory();
	else
		root["@makolab/library-react/dist/OneDaciaHeaderDesktopMenu"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 259);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/withWidth");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderMenu", function() { return HeaderMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_withWidth__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_withWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_withWidth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__direct_menu_link_direct_menu_link__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__direct_menu_link_direct_menu_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__direct_menu_link_direct_menu_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dropdown_dropdown__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__dropdown_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__dropdown_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mega_dropdown_mega_dropdown__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mega_dropdown_mega_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__mega_dropdown_mega_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__header_menu_jss__ = __webpack_require__(262);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeaderMenu=function(_Component){_inherits(HeaderMenu,_Component);function HeaderMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeaderMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeaderMenu.__proto__||Object.getPrototypeOf(HeaderMenu)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeKey:null,expandList:'',renderedMenuItems:{}},_this.expandSubCategory=function(column){var title=column.title;var expandList=_this.state.expandList;if(expandList.length===0||expandList!==title){_this.setState({expandList:title});}else{_this.setState({expandList:''});}},_this.handleMenuExpand=function(activeKey){_this.setState(function(prevState){if(prevState.activeKey!==activeKey){return{activeKey:activeKey};}return{activeKey:null};});},_this.onClick=function(key){var renderedMenuItems=_this.state.renderedMenuItems;!renderedMenuItems[key]&&_this.setState({renderedMenuItems:Object.assign({},_this.state.renderedMenuItems,_defineProperty({},key,true))});},_this.renderItem=function(link,key,active,onClick){var entryType=link.entryType,dropdown=link.dropdown,megaDropdown=link.megaDropdown;var _this$state=_this.state,expandList=_this$state.expandList,renderedMenuItems=_this$state.renderedMenuItems;switch(entryType){case'megaDropDown':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__direct_menu_link_direct_menu_link___default.a,{link:link,id:key,iconId:'dropicon',opened:active,onClick:onClick}),renderedMenuItems[key]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__mega_dropdown_mega_dropdown___default.a,{megaDropdown:megaDropdown.slice,expanded:active,id:key,expandList:expandList,expandSubCategory:_this.expandSubCategory}));case'dropDownList':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__direct_menu_link_direct_menu_link___default.a,{link:link,id:key,iconId:'dropicon',opened:active,onClick:onClick}),renderedMenuItems[key]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__dropdown_dropdown___default.a,{dropdown:dropdown.dropDownList,expanded:active,id:key}));case'directLink':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__direct_menu_link_direct_menu_link___default.a,{link:link,id:key});default:}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeaderMenu,[{key:'componentDidMount',value:function componentDidMount(){var links=this.props.links;var renderedMenuItems={};for(var i=0;i<links.length;i++){renderedMenuItems[i]=false;}this.setState({renderedMenuItems:renderedMenuItems});var element=document.getElementsByTagName('ul')[0];var self=this;window.addEventListener('click',function(e){!element.contains(e.target)&&self.setState({activeKey:null});});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,links=_props.links;var activeKey=this.state.activeKey;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.root)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.links)},links.map(function(link,key){var active=activeKey===key;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:key,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.link,key===0&&classes.linkHome,active&&classes.expanded),onBlur:_this2.onBlur,onClick:function onClick(){return _this2.onClick(key);}},_this2.renderItem(link,key,active,_this2.handleMenuExpand));})));}}]);return HeaderMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HeaderMenu.displayName='HeaderMenu';HeaderMenu.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,links:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired};/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_flow___default()([Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_9__header_menu_jss__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_5__material_ui_core_withWidth___default()()])(HeaderMenu));

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/OneDaciaHeaderDesktopMenuDirectLink");

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/OneDaciaHeaderDesktopMenuMegaDropdown");

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(theme){var _link;return{root:{flex:1},links:_defineProperty({display:'block',height:'100%',paddingLeft:0,margin:0},theme.breakpoints.up('md'),{display:'flex',alignItems:'center',justifyContent:'center'}),link:(_link={minWidth:'30',display:'flex',flexDirection:'column'},_defineProperty(_link,theme.breakpoints.up('md'),{borderBottom:'3px solid transparent',alignSelf:'stretch',justifyContent:'center',alignItems:'center'}),_defineProperty(_link,'&:hover',{borderColor:'#646b52','& button':{margin:0}}),_defineProperty(_link,'&:focus',{borderColor:'#646b52'}),_link),linkHome:_defineProperty({},theme.breakpoints.up('md'),{display:'none'}),expanded:_defineProperty({position:'absolute',top:0,width:'100%',height:'100%',zIndex:3},theme.breakpoints.up('md'),{position:'relative',width:'auto',backgroundColor:'transparent',zIndex:'auto'})};});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/flow");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/OneDaciaHeaderDesktopMenuDropdown");

/***/ })

/******/ });
});
//# sourceMappingURL=OneDaciaHeaderDesktopMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/OneDaciaHeaderDesktopMenu.js
// module id = 571
// module chunks = 0